export default {
	status: {
		400: "Żądanie nie powiodło się! Spróbuj ponownie później",
		401: "Sesja logowania wygasła! Zaloguj się ponownie",
		403: "Bieżące konto nie ma uprawnień dostępu",
		404: "Zasób, do którego próbujesz uzyskać dostęp, nie istnieje",
		405: "Nieprawidłowa metoda żądania! Spróbuj ponownie później",
		408: "Upłynął limit czasu żądania! Spróbuj ponownie później",
		500: "Usługa napotkała wyjątek",
		990: "Twoje konto zostało zamrożone z powodu nieukończonych zadań przez długi czas",
		10030008: "Przed złożeniem wniosku o wypłatę gotówki należy zwrócić fundusz pomocowy",
		10030010: "Kod zaproszenia nie istnieje",
		10030011: "Przekroczono maksymalną liczbę odpraw",
		10030012: "Nie spełniasz warunków odprawy, najpierw wykonaj zadanie",
		10030013: "Błąd konfiguracji logowania, skontaktuj się z obsługą klienta",
		10030014: "Nie w dozwolonym okresie czasu",
		10030015: "Członek nie istnieje",
		10030016:
			"Drogi użytkowniku: Gratulacje! Pomyślnie ukończyłeś 100% promocji swojego produktu. Skontaktuj się z pomocą techniczną platformy, aby poprosić o reset.",
		10030017: "Nie można dopasować produktu, prosimy o kontakt z obsługą klienta",
		10030018: "Niewystarczające saldo konta",
		10030019: "Konto zostało wyłączone",
		10030020: "Zakaz handlu na koncie",
		10030021: "Wypłata z konta zabroniona",
		10030022: "Błąd hasła transakcji",
		10030023: "Konto wypłaty nie jest powiązane, należy najpierw powiązać konto wypłaty",
		10030024: "Błąd starego hasła",
		10030027: "Wypłata jest ograniczona. Skontaktuj się z obsługą klienta, aby uzyskać więcej informacji",
		10030028: "Niska ocena kredytowa uniemożliwia pobranie pieniędzy",
		10030030: "Nie w dozwolonym okresie czasu",
		10030031: "Skontaktuj się z obsługą klienta, aby zresetować dzisiejsze zadanie",
		10030050: "Zamówienie wygasło. Proszę skontaktować się z obsługą klienta w celu uzyskania pomocy."
	},
	errorHandler: {
		InternalError: "Błąd wewnętrzny w silniku JavaScript",
		ReferenceError: "Nie znaleziono obiektu",
		TypeError: "Użyto nieprawidłowego typu lub obiektu",
		RangeError: "Parametr poza zakresem podczas korzystania z wbudowanych obiektów",
		SyntaxError: "Błąd składni",
		EvalError: "Nieprawidłowe użycie funkcji Eval",
		URIError: "Błąd URI",
		UnknownError: "Nieznany"
	},
	Network: {
		timedout: "Request timed out! Spróbuj ponownie później",
		error: "Błąd sieci! Spróbuj ponownie później"
	},
	request: {
		NoMoreData: "Brak więcej danych",
		OnlyImage: "Prześlij tylko pliki graficzne.",
		FileMaxSize: "Rozmiar pliku przekracza maksymalną wartość, która wynosi {0}M"
	},
	response: {
		loading: "Loading",
		success: "Success",
		fail: "Fail",
		complete: "Complete"
	},
	page: {
		noVerify: "Portfel niezweryfikowany, proszę najpierw zweryfikować portfel",
		notexist: "Przepraszamy, strona, do której próbujesz uzyskać dostęp, nie istnieje~"
	}
};
